import React from "react";
import { Colors } from "../../utils/colors";
import { OverlappingProfileAvatars } from "../overlappingProfileAvatars/OverlappingProfileAvatars";
import { SelectCircleInitialHeader } from "../selectCircleInitialHeader/SelectCircleInitialHeader";

type props = {};

export const SelectCircleInitial: React.FC<props> = () => {
  return (
    <div
      style={{
        backgroundColor: "white",
        borderRadius: 20,
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 20,
        paddingTop: 20,
        marginTop: 20,
      }}>
      <SelectCircleInitialHeader color={Colors.green} />
      {/* <OverlappingProfileAvatars /> */}
    </div>
  );
};
